export function getLinkToNounsWtf(path: string | undefined) {
  if (import.meta.env.VITE_DEPLOY_ENV === "prod") {
    return `https://nouns.wtf/${path}`;
  } else {
    return `https://ripe-v3-dao-fork-front-end--imaginative-arithmetic-48ce04.netlify.app/${path}`;
  }
}
